import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

/*
  index.js — Entry point
  Just mounts the React app. Nothing to change here.
*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
